import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faGithub,
  faTwitter,
  faHtml5,
  faPython,
  faJs,
  faBootstrap,
  faVuejs,
} from "@fortawesome/free-brands-svg-icons";
import {
  faCloud,
  faEnvelope,
  faPaintBrush,
  faDotCircle,
  faArrowCircleDown,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";

library.add(
  faArrowCircleDown,
  faCircle,
  faGithub,
  faTwitter,
  faHtml5,
  faPython,
  faJs,
  faDotCircle,
  faBootstrap,
  faVuejs,
  faCloud,
  faEnvelope,
  faPaintBrush
);
export default FontAwesomeIcon;
